import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import FacebookRounded from '@mui/icons-material/FacebookRounded';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Link as RouterLink } from 'react-router-dom';
import Typography from './modules/components/typography';
import withRoot from './with_root';

function Copyright() {
  return (
    <>
      {'© '}
      {new Date().getFullYear()}
      {' Personal Finance Toolkit'}
    </>
  );
}

const iconStyle = {
  width: 44,
  height: 44,
  borderRadius: 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'primary.main',
  color: 'white',
  mr: 1.5,
  transition: 'all 0.2s ease',
  '&:hover': {
    bgcolor: 'primary.dark',
    transform: 'translateY(-2px)'
  }
};

function AppFooter() {
  return (
    <Typography component="footer" sx={{ display: 'flex', bgcolor: 'background.paper' }}>
      <Container sx={{ my: 5, display: 'flex' }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Typography variant="h6" gutterBottom>
              PERSONAL FINANCE TOOLKIT
            </Typography>
            <Typography variant="body1">
              Practical tools and plain-English guidance to help you build resilient financial habits.
            </Typography>
          </Grid>
          <Grid item xs={12} md={5}>
            <Grid container justifyContent="flex-end" spacing={2}>
              <Grid item>
                <Typography variant="body2">
                  <Copyright />
                </Typography>
              </Grid>
              <Grid item>
                <Link component={RouterLink} to="/privacy" underline="hover">
                  Privacy
                </Link>
              </Grid>
              <Grid item>
                <Link component={RouterLink} to="/terms" underline="hover">
                  Terms
                </Link>
              </Grid>
              <Grid item sx={{ display: 'flex' }}>
                <Box component="a" href="https://facebook.com/" sx={iconStyle} aria-label="Facebook">
                  <FacebookRounded fontSize="small" />
                </Box>
                <Box component="a" href="https://twitter.com/" sx={iconStyle} aria-label="Twitter">
                  <TwitterIcon fontSize="small" />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Typography>
  );
}

export default withRoot(AppFooter);
